import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
import { GoogleTranslateWidget } from '../../../../components/GoogleTranslateWidget';
export function BlogPost7SignsGaslightingID() {
  const articleData = {
    title: '7 Tanda Gaslighting yang Terdeteksi AI Kami Secara Instan',
    description: 'Temukan 7 tanda gaslighting yang terdeteksi AI kami secara instan. Unggah teks Anda untuk mendeteksi manipulasi, penyangkalan, dan pola kekerasan emosional dalam hitungan detik.',
    slug: '7-signs-of-gaslighting',
    publishDate: '2025-01-14',
    author: 'Editorial Toxic Detector'
  };
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/blog/7-signs-of-gaslighting'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/blog/7-signs-of-gaslighting'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/blog/7-signs-of-gaslighting'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/blog/7-signs-of-gaslighting'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/blog/7-signs-of-gaslighting'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/blog/7-signs-of-gaslighting'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/blog/7-signs-of-gaslighting'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/blog/7-signs-of-gaslighting'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/blog/7-signs-of-gaslighting'
  }];
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: window.location.href
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Tautan disalin ke papan klip!');
    }
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Apa tanda-tanda awal gaslighting dalam suatu hubungan?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Tanda-tanda awal termasuk penyangkalan peristiwa, memutarbalikkan fakta, meminimalkan perasaan Anda, dan menyalahkan. Pola-pola ini secara bertahap membuat Anda meragukan persepsi Anda sendiri.'
      }
    }, {
      '@type': 'Question',
      name: 'Bisakah gaslighting benar-benar terjadi melalui pesan teks?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ya. Gaslighting melalui teks sangat umum. Pesan bisa manipulatif, mendistorsi fakta, atau membuat rasa bersalah. AI kami mendeteksi pola-pola ini secara instan dari riwayat obrolan Anda.'
      }
    }, {
      '@type': 'Question',
      name: 'Bagaimana AI Toxic Detector mengidentifikasi pola gaslighting?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Toxic Detector menganalisis perubahan nada, kontradiksi, pola menyalahkan, minimisasi emosional, bahasa yang memicu rasa bersalah, dan perbedaan perilaku publik vs pribadi.'
      }
    }, {
      '@type': 'Question',
      name: 'Apa perbedaan antara gaslighting dan ketidaksepakatan normal?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ketidaksepakatan normal melibatkan dua perspektif. Gaslighting melibatkan upaya yang disengaja atau berulang untuk mendistorsi realitas Anda, membatalkan emosi Anda, atau membuat Anda mempertanyakan kewarasan Anda.'
      }
    }, {
      '@type': 'Question',
      name: 'Mengapa orang melakukan gaslighting dalam hubungan?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Gaslighter sering menginginkan kontrol, menghindari tanggung jawab, atau memanipulasi emosi pasangannya. Banyak yang mengulangi pola yang dipelajari tanpa menyadari kerusakannya.'
      }
    }, {
      '@type': 'Question',
      name: 'Bisakah gaslighting tidak disengaja?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ya, beberapa orang melakukan gaslighting tanpa menyadarinya. Perilaku tersebut mungkin berasal dari rasa tidak aman, penghindaran, atau kebiasaan komunikasi beracun yang dipelajari.'
      }
    }, {
      '@type': 'Question',
      name: 'Apa yang harus saya lakukan jika saya pikir pasangan saya melakukan gaslighting?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Percayai insting Anda, dokumentasikan percakapan, bicaralah dengan seseorang yang Anda percayai, dan pertimbangkan untuk mendapatkan perspektif profesional. Alat seperti Toxic Detector dapat membantu mengonfirmasi pola.'
      }
    }, {
      '@type': 'Question',
      name: 'Apakah gaslighting merupakan bentuk kekerasan emosional?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ya. Gaslighting diakui sebagai bentuk kekerasan psikologis dan emosional karena memanipulasi persepsi seseorang tentang realitas.'
      }
    }, {
      '@type': 'Question',
      name: 'Seberapa akurat Toxic Detector dalam mendeteksi manipulasi?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'AI kami menganalisis pola linguistik, nada, dan perilaku dalam pesan Anda dengan akurasi tinggi. Ini memberikan laporan yang jelas dan dapat dibagikan yang didukung oleh analisis perilaku yang konsisten.'
      }
    }, {
      '@type': 'Question',
      name: 'Apakah gaslighting memburuk seiring waktu?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Gaslighting sering meningkat secara bertahap. Saat korban menjadi lebih bingung atau bergantung, manipulator meningkatkan kontrol dan mengintensifkan tekanan emosional.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/89an98a4aCmEYGiFGxbV6q/1763120076017.jpg',
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    }
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-6671">
      <GoogleTranslateWidget data-id="element-6672" />
      <Helmet data-id="element-6673">
        <title data-id="element-6674">
          7 Tanda Gaslighting (Terdeteksi AI) — Hentikan Manipulasi |
          ToxicDetector
        </title>
        <meta name="description" content="Pikir seseorang melakukan gaslighting pada Anda? AI kami mengungkapkan 7 tanda teratas secara instan dengan menganalisis obrolan Anda." data-id="element-6675" />
        <meta name="keywords" content="tanda gaslighting, contoh gaslighting, gaslighting dalam pesan teks, perilaku manipulatif, detektor gaslighting AI" data-id="element-6676" />
        <meta name="language" content="id" data-id="element-6677" />
        <link rel="canonical" href="https://toxicdetector.com/id/blog/7-signs-of-gaslighting" data-id="element-6678" />
        {alternateUrls.map(alternate => <link key={alternate.lang} rel="alternate" hrefLang={alternate.lang} href={alternate.url} data-id="element-6679" />)}
        <meta property="og:type" content="article" data-id="element-6680" />
        <meta property="og:title" content="7 Tanda Gaslighting yang Terdeteksi AI Kami Secara Instan" data-id="element-6681" />
        <meta property="og:description" content="Pikir seseorang melakukan gaslighting pada Anda? AI kami mengungkapkan 7 tanda teratas secara instan dengan menganalisis obrolan Anda." data-id="element-6682" />
        <meta property="og:url" content="https://toxicdetector.com/id/blog/7-signs-of-gaslighting" data-id="element-6683" />
        <meta property="og:image" content="https://cdn.magicpatterns.com/uploads/9AgsYP8bczHQvssTJAPniL/file_00000000842c7243a7657dadb3d089c4.png" data-id="element-6684" />
        <meta property="og:locale" content="id_ID" data-id="element-6685" />
        <meta name="twitter:card" content="summary_large_image" data-id="element-6686" />
        <meta name="twitter:title" content="7 Tanda Gaslighting (Terdeteksi AI)" data-id="element-6687" />
        <meta name="twitter:description" content="AI kami mengungkapkan 7 tanda teratas gaslighting secara instan dengan menganalisis obrolan Anda." data-id="element-6688" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/89an98a4aCmEYGiFGxbV6q/1763120076017.jpg" data-id="element-6689" />
        <script type="application/ld+json" data-id="element-6690">
          {JSON.stringify(articleSchema)}
        </script>
        <script type="application/ld+json" data-id="element-6691">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-6692">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-6693">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-6694">
            <div className="flex items-center justify-between" data-id="element-6695">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-6696">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Bagikan artikel" data-id="element-6697">
                <Share2 size={20} className="text-gray-600" data-id="element-6698" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-6699">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-6700">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-6701" />
            Kembali ke Blog
          </Link>

          <header className="mb-12" data-id="element-6702">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-6703">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-6704">
              <time dateTime={articleData.publishDate} data-id="element-6705">
                {new Date(articleData.publishDate).toLocaleDateString('id-ID', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-6706">•</span>
              <span data-id="element-6707">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-6708">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/89an98a4aCmEYGiFGxbV6q/1763120076017.jpg" alt="AI mendeteksi tanda-tanda gaslighting dalam teks hubungan" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-6709" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-6710">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-6711">Daftar Isi</h2>
            <ul className="space-y-3 text-sm" data-id="element-6712">
              <li data-id="element-6713">
                <a href="#denying" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6714">
                  <span className="text-gray-400" data-id="element-6715">→</span> 1. Menyangkal Apa
                  yang Terjadi
                </a>
              </li>
              <li data-id="element-6716">
                <a href="#twisting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6717">
                  <span className="text-gray-400" data-id="element-6718">→</span> 2. Memutarbalikkan
                  Fakta
                </a>
              </li>
              <li data-id="element-6719">
                <a href="#trivializing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6720">
                  <span className="text-gray-400" data-id="element-6721">→</span> 3. Meremehkan
                  Perasaan Anda
                </a>
              </li>
              <li data-id="element-6722">
                <a href="#shifting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6723">
                  <span className="text-gray-400" data-id="element-6724">→</span> 4. Mengalihkan
                  Kesalahan
                </a>
              </li>
              <li data-id="element-6725">
                <a href="#victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6726">
                  <span className="text-gray-400" data-id="element-6727">→</span> 5. Bermain Korban
                </a>
              </li>
              <li data-id="element-6728">
                <a href="#overtime" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6729">
                  <span className="text-gray-400" data-id="element-6730">→</span> 6. Gaslighting
                  Seiring Waktu
                </a>
              </li>
              <li data-id="element-6731">
                <a href="#tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6732">
                  <span className="text-gray-400" data-id="element-6733">→</span> 7. Perubahan Nada
                  Publik vs Pribadi
                </a>
              </li>
              <li data-id="element-6734">
                <a href="#faq" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6735">
                  <span className="text-gray-400" data-id="element-6736">→</span> Pertanyaan yang
                  Sering Diajukan
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-6737">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-6738">
              Pernah merasa seperti Anda kehilangan akal dalam suatu hubungan?
              🚩 Mungkin pasangan Anda mengatakan satu hal, tetapi naluri Anda
              mengatakan hal lain. Itu disebut <strong data-id="element-6739">gaslighting</strong>,
              perilaku manipulatif halus yang dirancang untuk membuat Anda
              meragukan diri sendiri.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-6740">
              Kebanyakan orang melewatkan tanda-tanda gaslighting, tetapi AI
              kami mendeteksinya secara instan dengan menganalisis obrolan Anda
              untuk mengungkapkan kebenaran. Berikut adalah 7 tanda gaslighting
              yang ditangkap AI kami sehingga Anda tidak perlu melakukannya.
            </p>

            <section id="denying" className="mb-12" data-id="element-6741">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6742">
                1️⃣ Menyangkal Apa yang Terjadi
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6743">
                <p className="italic text-gray-700 text-lg" data-id="element-6744">
                  "Aku tidak pernah mengatakan itu."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6745">
                Terdengar akrab? Gaslighter sering menyangkal fakta atau
                peristiwa untuk membingungkan Anda. AI mendeteksi kontradiksi
                berulang dan menandai pesan yang mencoba menghapus kenyataan.
              </p>
            </section>

            <section id="twisting" className="mb-12" data-id="element-6746">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6747">
                2️⃣ Memutarbalikkan Fakta
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6748">
                <p className="italic text-gray-700 text-lg" data-id="element-6749">
                  "Kamu hanya membayangkan sesuatu."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6750">
                Langkah klasik ini membuat Anda mempertanyakan ingatan Anda. AI
                menandai ketika pesan dimanipulasi atau dibingkai ulang secara
                selektif untuk membuat Anda ragu.
              </p>
            </section>

            <section id="trivializing" className="mb-12" data-id="element-6751">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6752">
                3️⃣ Meremehkan Perasaan Anda
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6753">
                <p className="italic text-gray-700 text-lg" data-id="element-6754">
                  "Kamu terlalu sensitif."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6755">
                Meminimalkan emosi Anda adalah tanda bahaya besar. AI mendeteksi
                pola nada yang menolak atau merendahkan perasaan Anda.
              </p>
            </section>

            <section id="shifting" className="mb-12" data-id="element-6756">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6757">
                4️⃣ Mengalihkan Kesalahan
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6758">
                <p className="italic text-gray-700 text-lg" data-id="element-6759">"Ini salahmu."</p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6760">
                Pernah memperhatikan bagaimana argumen selalu berakhir menjadi
                "salahmu"? AI menyoroti upaya berulang untuk mengalihkan
                tanggung jawab, sehingga Anda dapat melihat polanya dengan
                jelas.
              </p>
            </section>

            <section id="victim" className="mb-12" data-id="element-6761">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6762">
                5️⃣ Bermain Korban
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6763">
                <p className="italic text-gray-700 text-lg" data-id="element-6764">
                  "Setelah semua yang aku lakukan untukmu..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6765">
                Membuat rasa bersalah adalah bentuk kontrol yang halus. AI
                menandai frasa manipulatif yang dirancang untuk membuat Anda
                merasa buruk atau meminta maaf secara berlebihan.
              </p>
            </section>

            <section id="overtime" className="mb-12" data-id="element-6766">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6767">
                6️⃣ Gaslighting Seiring Waktu ⏳
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6768">
                Gaslighting tidak selalu jelas. Itu dibangun secara bertahap. AI
                melacak pola di berbagai percakapan, memberi Anda pandangan
                menyeluruh tentang perilaku beracun.
              </p>
            </section>

            <section id="tone" className="mb-12" data-id="element-6769">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6770">
                7️⃣ Perubahan Nada Publik vs Pribadi
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6771">
                <p className="italic text-gray-700 text-lg" data-id="element-6772">
                  Grup chat: 😊 / 1:1: 😡
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6773">
                Beberapa gaslighter berperilaku berbeda di depan umum
                dibandingkan pesan pribadi. AI menangkap perbedaan dan menyoroti
                perubahan suasana hati yang tiba-tiba atau agresi tersembunyi.
              </p>
            </section>

            <section className="mb-12" data-id="element-6774">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6775">
                🛡 Cara Melindungi Diri Sendiri
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-6776">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-6777">
                  <li className="flex items-start gap-3" data-id="element-6778">
                    <span className="text-purple-600 font-bold" data-id="element-6779">•</span>
                    <span data-id="element-6780">Percayai insting Anda.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6781">
                    <span className="text-purple-600 font-bold" data-id="element-6782">•</span>
                    <span data-id="element-6783">Simpan catatan percakapan.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6784">
                    <span className="text-purple-600 font-bold" data-id="element-6785">•</span>
                    <span data-id="element-6786">Bicaralah dengan teman atau terapis.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6787">
                    <span className="text-purple-600 font-bold" data-id="element-6788">•</span>
                    <span data-id="element-6789">
                      Yang paling penting: jangan abaikan tanda bahaya.
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-6790">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6791">
                💀 Mengapa AI Kami Berhasil
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-6792">
                Tidak seperti manusia atau chatbot umum, Toxic Detector
                memberikan:
              </p>
              <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6" data-id="element-6793">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-6794">
                  <li className="flex items-start gap-3" data-id="element-6795">
                    <span className="text-purple-600 font-bold" data-id="element-6796">•</span>
                    <span data-id="element-6797">Unggah tangkapan layar satu ketukan</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6798">
                    <span className="text-purple-600 font-bold" data-id="element-6799">•</span>
                    <span data-id="element-6800">Hasil instan yang dapat dibagikan</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6801">
                    <span className="text-purple-600 font-bold" data-id="element-6802">•</span>
                    <span data-id="element-6803">
                      Hasil emosional dan dapat dipercaya yang benar-benar dapat
                      Anda andalkan
                    </span>
                  </li>
                </ul>
              </div>
              <p className="text-lg font-semibold text-gray-900" data-id="element-6804">
                Berhenti bertanya-tanya. Mulai mengetahui. 💖
              </p>
            </section>

            <section id="faq" className="mb-12" data-id="element-6805">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6806">
                Pertanyaan yang Sering Diajukan
              </h2>
              <div className="space-y-4" data-id="element-6807">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-6808">
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-6809">
                      <span data-id="element-6810">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-6811" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-6812">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-6813">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-6814">
              💀 Siap Melihat Kebenaran?
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-6815">
              Gaslighting itu halus, berbahaya, dan melelahkan, tetapi AI kami
              dapat membuatnya sangat jelas. Unggah obrolan Anda dan dapatkan
              laporan toksisitas instan Anda.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-6816">
              <p className="font-bold text-xl" data-id="element-6817">
                "🚩 83% beracun. Waspadalah terhadap manipulasi!"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-6818">
              Pindai Obrolan Anda Sekarang →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: 'Pelajari Tentang Istilah: Narsisme & Gaslighting',
          description: 'Pahami psikologi di balik taktik manipulasi narsisme dan gaslighting.',
          slug: 'narcissism-gaslighting-explained',
          emoji: '💀'
        }, {
          title: 'Apakah Mantan Anda Narsisis Terselubung?',
          description: 'Temukan jika mantan Anda menunjukkan tanda-tanda perilaku narsisis terselubung melalui analisis teks.',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }]} data-id="element-6819" />

          <div className="mt-12 text-center" data-id="element-6820">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-6821">
              <Share2 size={18} className="mr-2" data-id="element-6822" />
              Bagikan artikel ini
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-6823">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-6824">
            <p className="text-gray-500 text-sm" data-id="element-6825">
              © {new Date().getFullYear()} ToxicDetector. Hak cipta dilindungi
              undang-undang.
            </p>
          </div>
        </footer>
      </div>
    </div>;
}